import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { charmGray, white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'grid',
		gridTemplateColumns: 'auto 1fr',
		gap: 16,
		backgroundColor: white,
		padding: 16,
		flex: 1,
		overflow: 'hidden',
		boxSizing: 'border-box',
		[THEME.queries.lg]: {
			gridTemplateColumns: '1fr',
			gridTemplateRows: 'auto 1fr',
		},
	},
	tabListScrollArea: {
		height: '100%',
	},
	tabList: {
		height: 'auto !important',
		overflow: 'auto',
	},
	tabContent: {
		overflow: 'auto',
	},
	// For content that scrolls itself; on `auto` the tab would scroll too and show a second scrollbar.
	selfScrollingTabContent: {
		overflow: 'hidden',
	},
	tagsTabContent: {
		overflow: 'hidden',
	},
	mobileNav: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		boxSizing: 'border-box',
		padding: 8,
	},
	mobileNavTrigger: {
		width: '100%',
		justifyContent: 'flex-start',
	},
	mobileNavList: {
		maxHeight: 320,
		overflowY: 'auto',
		':is([data-orientation="vertical"])': {
			borderRight: 'none',
		},
	},
	accountDetailsHeader: {
		boxSizing: 'border-box',
		paddingTop: 24,
	},
	integrationsSearchInput: {
		marginBottom: 20,
		maxWidth: 400,
		width: '100%',
	},
	placeholderContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		color: '#999',
		fontSize: 18,
	},
	/**
	 * A desktop floor for tabs whose content cannot reflow, so they keep their shape and the page
	 * scrolls sideways instead of squashing them. See `contentStylesForTab` for who does not get it.
	 */
	content: {
		minWidth: 1118,
	},
	unauthorized: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		gap: 8,
	},
	contentCalendarButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: charmGray,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
		padding: '16px 16px 8px 16px',
		':hover': {
			backgroundColor: '#f7fafc',
		},
	},
	textingSubViewToggle: {
		marginTop: THEME.spacing.md,
	},
});

/**
 * The shell's content column, floored for most tabs and left fluid for the settings tab.
 *
 * Settings measures its own container and lays itself out from that width, so a floor under it only
 * ever made the page scroll sideways: the hub cards ran off the right edge instead of resizing, and
 * the column count moved on a width that had stopped tracking the window — two columns, then one,
 * then two again as the window kept narrowing, because the tab rail collapsing at `THEME.queries.lg`
 * handed the pinned column its width back.
 *
 * Both arrays are built once. The layout is an `observer`, so it is memoised, and handing it a fresh
 * array every render would defeat that — as the inline literal this replaced did.
 */
const FLOORED_CONTENT = [styleSheet.content];
const FLUID_CONTENT: typeof FLOORED_CONTENT = [];

export const contentStylesForTab = (tab: string) => (tab === 'settings' ? FLUID_CONTENT : FLOORED_CONTENT);
